module.exports = __webpack_public_path__ + "static/media/archer_destination_selected.e7e63524.svg";